module.exports = __webpack_public_path__ + "54c8ab96aeed2aef5646e611e73bac5f.pdf";